var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71696 4.66346L5.5 1.42414L1.28304 4.66346C1.1417 4.77159 0.950497 4.83228 0.751202 4.83228C0.551907 4.83228 0.360709 4.77159 0.219367 4.66346C0.0788636 4.5547 0 4.40756 0 4.25419C0 4.10083 0.0788636 3.95369 0.219367 3.84493L5.0172 0.152797C5.14572 0.0549517 5.31921 7.05719e-05 5.5 7.05719e-05C5.68079 7.05719e-05 5.85428 0.0549517 5.9828 0.152797L10.7806 3.84493C10.9211 3.95369 11 4.10083 11 4.25419C11 4.40756 10.9211 4.5547 10.7806 4.66346C10.6393 4.77159 10.4481 4.83228 10.2488 4.83228C10.0495 4.83228 9.8583 4.77159 9.71696 4.66346Z",
    fill: "#F5831F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3a9a784d3ebb045d2042aef5f1b17ac3.svg";
export { ForwardRef as ReactComponent };